import { render, staticRenderFns } from "./CreateAssistant.second.step.vue?vue&type=template&id=5db0d822&scoped=true&"
import script from "./CreateAssistant.second.step.vue?vue&type=script&lang=js&"
export * from "./CreateAssistant.second.step.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssistant.second.step.vue?vue&type=style&index=0&id=5db0d822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0d822",
  null
  
)

export default component.exports